/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestErrorsRouteImport } from './routes/testErrors'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PasswordlessRouteImport } from './routes/passwordless'
import { Route as LoginRouteImport } from './routes/login'
import { Route as EnrollRouteImport } from './routes/enroll'
import { Route as ConciergeRouteImport } from './routes/concierge'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedWelcomeRouteImport } from './routes/_authenticated/welcome'
import { Route as AuthenticatedSessionsRouteImport } from './routes/_authenticated/sessions'
import { Route as AuthenticatedMyMideoFamilyRouteImport } from './routes/_authenticated/myMideoFamily'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedPatientIdRouteImport } from './routes/_authenticated/$patientId'
import { Route as AuthenticatedPatientIdIndexRouteImport } from './routes/_authenticated/$patientId/index'
import { Route as AuthenticatedSessionsSessionIdRouteImport } from './routes/_authenticated/sessions.$sessionId'
import { Route as AuthenticatedPatientIdProfileRouteImport } from './routes/_authenticated/$patientId/profile'
import { Route as AuthenticatedPatientIdStatementIndexRouteImport } from './routes/_authenticated/$patientId/statement/index'
import { Route as AuthenticatedPatientIdPaymentIndexRouteImport } from './routes/_authenticated/$patientId/payment/index'
import { Route as AuthenticatedPatientIdOnboardingIndexRouteImport } from './routes/_authenticated/$patientId/onboarding/index'
import { Route as AuthenticatedPatientIdInfoIndexRouteImport } from './routes/_authenticated/$patientId/info/index'
import { Route as AuthenticatedPatientIdEducationIndexRouteImport } from './routes/_authenticated/$patientId/education/index'
import { Route as AuthenticatedPatientIdCareTeamIndexRouteImport } from './routes/_authenticated/$patientId/careTeam/index'
import { Route as AuthenticatedPatientIdCardIndexRouteImport } from './routes/_authenticated/$patientId/card/index'
import { Route as AuthenticatedPatientIdStatementRecordingRouteImport } from './routes/_authenticated/$patientId/statement/recording'
import { Route as AuthenticatedPatientIdStatementInstructionalVideosRouteImport } from './routes/_authenticated/$patientId/statement/instructionalVideos'
import { Route as AuthenticatedPatientIdStatementFinalSignaturesRouteImport } from './routes/_authenticated/$patientId/statement/finalSignatures'
import { Route as AuthenticatedPatientIdStatementAttestationRouteImport } from './routes/_authenticated/$patientId/statement/attestation'
import { Route as AuthenticatedPatientIdPaymentThanksRouteImport } from './routes/_authenticated/$patientId/payment/thanks'
import { Route as AuthenticatedPatientIdPaymentSelfPayRouteImport } from './routes/_authenticated/$patientId/payment/selfPay'
import { Route as AuthenticatedPatientIdPaymentMedicareInfoRouteImport } from './routes/_authenticated/$patientId/payment/medicareInfo'
import { Route as AuthenticatedPatientIdPaymentMedicareABNRouteImport } from './routes/_authenticated/$patientId/payment/medicareABN'
import { Route as AuthenticatedPatientIdPaymentInsuranceInfoRouteImport } from './routes/_authenticated/$patientId/payment/insuranceInfo'
import { Route as AuthenticatedPatientIdPaymentInsuranceABNRouteImport } from './routes/_authenticated/$patientId/payment/insuranceABN'
import { Route as AuthenticatedPatientIdPaymentConfirmPackageRouteImport } from './routes/_authenticated/$patientId/payment/confirmPackage'
import { Route as AuthenticatedPatientIdPaymentAobRouteImport } from './routes/_authenticated/$patientId/payment/aob'
import { Route as AuthenticatedPatientIdOnboardingSelectRouteImport } from './routes/_authenticated/$patientId/onboarding/select'
import { Route as AuthenticatedPatientIdOnboardingQuestionnaireRouteImport } from './routes/_authenticated/$patientId/onboarding/questionnaire'
import { Route as AuthenticatedPatientIdOnboardingOnboardingPaymentRouteImport } from './routes/_authenticated/$patientId/onboarding/onboardingPayment'
import { Route as AuthenticatedPatientIdOnboardingLearnRouteImport } from './routes/_authenticated/$patientId/onboarding/learn'
import { Route as AuthenticatedPatientIdOnboardingFinalRouteImport } from './routes/_authenticated/$patientId/onboarding/final'
import { Route as AuthenticatedPatientIdInfoPhotoForCardRouteImport } from './routes/_authenticated/$patientId/info/photoForCard'
import { Route as AuthenticatedPatientIdInfoPatientInfoRouteImport } from './routes/_authenticated/$patientId/info/patientInfo'
import { Route as AuthenticatedPatientIdInfoGovIdRouteImport } from './routes/_authenticated/$patientId/info/govId'
import { Route as AuthenticatedPatientIdInfoFilesRouteImport } from './routes/_authenticated/$patientId/info/files'
import { Route as AuthenticatedPatientIdInfoConsentFormsRouteImport } from './routes/_authenticated/$patientId/info/consentForms'
import { Route as AuthenticatedPatientIdEducationTreatmentOptionRouteImport } from './routes/_authenticated/$patientId/education/treatmentOption'
import { Route as AuthenticatedPatientIdEducationPatientEducationRouteImport } from './routes/_authenticated/$patientId/education/patientEducation'
import { Route as AuthenticatedPatientIdCareTeamHospitalInfoRouteImport } from './routes/_authenticated/$patientId/careTeam/hospitalInfo'
import { Route as AuthenticatedPatientIdCareTeamHcaInfoRouteImport } from './routes/_authenticated/$patientId/careTeam/hcaInfo'
import { Route as AuthenticatedPatientIdCareTeamDoctorInfoRouteImport } from './routes/_authenticated/$patientId/careTeam/doctorInfo'
import { Route as AuthenticatedPatientIdCareTeamAttorneyInfoRouteImport } from './routes/_authenticated/$patientId/careTeam/attorneyInfo'
import { Route as AuthenticatedPatientIdCareTeamAlternateAgentsRouteImport } from './routes/_authenticated/$patientId/careTeam/alternateAgents'
import { Route as AuthenticatedPatientIdCardShareRouteImport } from './routes/_authenticated/$patientId/card/share'
import { Route as AuthenticatedPatientIdCardCardReviewRouteImport } from './routes/_authenticated/$patientId/card/cardReview'
import { Route as AuthenticatedPatientIdCardAddWidgetRouteImport } from './routes/_authenticated/$patientId/card/addWidget'
import { Route as AuthenticatedPatientIdCardAddToWalletRouteImport } from './routes/_authenticated/$patientId/card/addToWallet'

const TestErrorsRoute = TestErrorsRouteImport.update({
  id: '/testErrors',
  path: '/testErrors',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordlessRoute = PasswordlessRouteImport.update({
  id: '/passwordless',
  path: '/passwordless',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const EnrollRoute = EnrollRouteImport.update({
  id: '/enroll',
  path: '/enroll',
  getParentRoute: () => rootRouteImport,
} as any)
const ConciergeRoute = ConciergeRouteImport.update({
  id: '/concierge',
  path: '/concierge',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWelcomeRoute = AuthenticatedWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSessionsRoute = AuthenticatedSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMyMideoFamilyRoute =
  AuthenticatedMyMideoFamilyRouteImport.update({
    id: '/myMideoFamily',
    path: '/myMideoFamily',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPatientIdRoute = AuthenticatedPatientIdRouteImport.update({
  id: '/$patientId',
  path: '/$patientId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPatientIdIndexRoute =
  AuthenticatedPatientIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedSessionsSessionIdRoute =
  AuthenticatedSessionsSessionIdRouteImport.update({
    id: '/$sessionId',
    path: '/$sessionId',
    getParentRoute: () => AuthenticatedSessionsRoute,
  } as any)
const AuthenticatedPatientIdProfileRoute =
  AuthenticatedPatientIdProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdStatementIndexRoute =
  AuthenticatedPatientIdStatementIndexRouteImport.update({
    id: '/statement/',
    path: '/statement/',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdPaymentIndexRoute =
  AuthenticatedPatientIdPaymentIndexRouteImport.update({
    id: '/payment/',
    path: '/payment/',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdOnboardingIndexRoute =
  AuthenticatedPatientIdOnboardingIndexRouteImport.update({
    id: '/onboarding/',
    path: '/onboarding/',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdInfoIndexRoute =
  AuthenticatedPatientIdInfoIndexRouteImport.update({
    id: '/info/',
    path: '/info/',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdEducationIndexRoute =
  AuthenticatedPatientIdEducationIndexRouteImport.update({
    id: '/education/',
    path: '/education/',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdCareTeamIndexRoute =
  AuthenticatedPatientIdCareTeamIndexRouteImport.update({
    id: '/careTeam/',
    path: '/careTeam/',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdCardIndexRoute =
  AuthenticatedPatientIdCardIndexRouteImport.update({
    id: '/card/',
    path: '/card/',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdStatementRecordingRoute =
  AuthenticatedPatientIdStatementRecordingRouteImport.update({
    id: '/statement/recording',
    path: '/statement/recording',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdStatementInstructionalVideosRoute =
  AuthenticatedPatientIdStatementInstructionalVideosRouteImport.update({
    id: '/statement/instructionalVideos',
    path: '/statement/instructionalVideos',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdStatementFinalSignaturesRoute =
  AuthenticatedPatientIdStatementFinalSignaturesRouteImport.update({
    id: '/statement/finalSignatures',
    path: '/statement/finalSignatures',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdStatementAttestationRoute =
  AuthenticatedPatientIdStatementAttestationRouteImport.update({
    id: '/statement/attestation',
    path: '/statement/attestation',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdPaymentThanksRoute =
  AuthenticatedPatientIdPaymentThanksRouteImport.update({
    id: '/payment/thanks',
    path: '/payment/thanks',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdPaymentSelfPayRoute =
  AuthenticatedPatientIdPaymentSelfPayRouteImport.update({
    id: '/payment/selfPay',
    path: '/payment/selfPay',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdPaymentMedicareInfoRoute =
  AuthenticatedPatientIdPaymentMedicareInfoRouteImport.update({
    id: '/payment/medicareInfo',
    path: '/payment/medicareInfo',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdPaymentMedicareABNRoute =
  AuthenticatedPatientIdPaymentMedicareABNRouteImport.update({
    id: '/payment/medicareABN',
    path: '/payment/medicareABN',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdPaymentInsuranceInfoRoute =
  AuthenticatedPatientIdPaymentInsuranceInfoRouteImport.update({
    id: '/payment/insuranceInfo',
    path: '/payment/insuranceInfo',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdPaymentInsuranceABNRoute =
  AuthenticatedPatientIdPaymentInsuranceABNRouteImport.update({
    id: '/payment/insuranceABN',
    path: '/payment/insuranceABN',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdPaymentConfirmPackageRoute =
  AuthenticatedPatientIdPaymentConfirmPackageRouteImport.update({
    id: '/payment/confirmPackage',
    path: '/payment/confirmPackage',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdPaymentAobRoute =
  AuthenticatedPatientIdPaymentAobRouteImport.update({
    id: '/payment/aob',
    path: '/payment/aob',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdOnboardingSelectRoute =
  AuthenticatedPatientIdOnboardingSelectRouteImport.update({
    id: '/onboarding/select',
    path: '/onboarding/select',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdOnboardingQuestionnaireRoute =
  AuthenticatedPatientIdOnboardingQuestionnaireRouteImport.update({
    id: '/onboarding/questionnaire',
    path: '/onboarding/questionnaire',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdOnboardingOnboardingPaymentRoute =
  AuthenticatedPatientIdOnboardingOnboardingPaymentRouteImport.update({
    id: '/onboarding/onboardingPayment',
    path: '/onboarding/onboardingPayment',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdOnboardingLearnRoute =
  AuthenticatedPatientIdOnboardingLearnRouteImport.update({
    id: '/onboarding/learn',
    path: '/onboarding/learn',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdOnboardingFinalRoute =
  AuthenticatedPatientIdOnboardingFinalRouteImport.update({
    id: '/onboarding/final',
    path: '/onboarding/final',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdInfoPhotoForCardRoute =
  AuthenticatedPatientIdInfoPhotoForCardRouteImport.update({
    id: '/info/photoForCard',
    path: '/info/photoForCard',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdInfoPatientInfoRoute =
  AuthenticatedPatientIdInfoPatientInfoRouteImport.update({
    id: '/info/patientInfo',
    path: '/info/patientInfo',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdInfoGovIdRoute =
  AuthenticatedPatientIdInfoGovIdRouteImport.update({
    id: '/info/govId',
    path: '/info/govId',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdInfoFilesRoute =
  AuthenticatedPatientIdInfoFilesRouteImport.update({
    id: '/info/files',
    path: '/info/files',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdInfoConsentFormsRoute =
  AuthenticatedPatientIdInfoConsentFormsRouteImport.update({
    id: '/info/consentForms',
    path: '/info/consentForms',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdEducationTreatmentOptionRoute =
  AuthenticatedPatientIdEducationTreatmentOptionRouteImport.update({
    id: '/education/treatmentOption',
    path: '/education/treatmentOption',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdEducationPatientEducationRoute =
  AuthenticatedPatientIdEducationPatientEducationRouteImport.update({
    id: '/education/patientEducation',
    path: '/education/patientEducation',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdCareTeamHospitalInfoRoute =
  AuthenticatedPatientIdCareTeamHospitalInfoRouteImport.update({
    id: '/careTeam/hospitalInfo',
    path: '/careTeam/hospitalInfo',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdCareTeamHcaInfoRoute =
  AuthenticatedPatientIdCareTeamHcaInfoRouteImport.update({
    id: '/careTeam/hcaInfo',
    path: '/careTeam/hcaInfo',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdCareTeamDoctorInfoRoute =
  AuthenticatedPatientIdCareTeamDoctorInfoRouteImport.update({
    id: '/careTeam/doctorInfo',
    path: '/careTeam/doctorInfo',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdCareTeamAttorneyInfoRoute =
  AuthenticatedPatientIdCareTeamAttorneyInfoRouteImport.update({
    id: '/careTeam/attorneyInfo',
    path: '/careTeam/attorneyInfo',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdCareTeamAlternateAgentsRoute =
  AuthenticatedPatientIdCareTeamAlternateAgentsRouteImport.update({
    id: '/careTeam/alternateAgents',
    path: '/careTeam/alternateAgents',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdCardShareRoute =
  AuthenticatedPatientIdCardShareRouteImport.update({
    id: '/card/share',
    path: '/card/share',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdCardCardReviewRoute =
  AuthenticatedPatientIdCardCardReviewRouteImport.update({
    id: '/card/cardReview',
    path: '/card/cardReview',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdCardAddWidgetRoute =
  AuthenticatedPatientIdCardAddWidgetRouteImport.update({
    id: '/card/addWidget',
    path: '/card/addWidget',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)
const AuthenticatedPatientIdCardAddToWalletRoute =
  AuthenticatedPatientIdCardAddToWalletRouteImport.update({
    id: '/card/addToWallet',
    path: '/card/addToWallet',
    getParentRoute: () => AuthenticatedPatientIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/concierge': typeof ConciergeRoute
  '/enroll': typeof EnrollRoute
  '/login': typeof LoginRoute
  '/passwordless': typeof PasswordlessRoute
  '/privacy': typeof PrivacyRoute
  '/testErrors': typeof TestErrorsRoute
  '/$patientId': typeof AuthenticatedPatientIdRouteWithChildren
  '/home': typeof AuthenticatedHomeRoute
  '/myMideoFamily': typeof AuthenticatedMyMideoFamilyRoute
  '/sessions': typeof AuthenticatedSessionsRouteWithChildren
  '/welcome': typeof AuthenticatedWelcomeRoute
  '/$patientId/profile': typeof AuthenticatedPatientIdProfileRoute
  '/sessions/$sessionId': typeof AuthenticatedSessionsSessionIdRoute
  '/$patientId/': typeof AuthenticatedPatientIdIndexRoute
  '/$patientId/card/addToWallet': typeof AuthenticatedPatientIdCardAddToWalletRoute
  '/$patientId/card/addWidget': typeof AuthenticatedPatientIdCardAddWidgetRoute
  '/$patientId/card/cardReview': typeof AuthenticatedPatientIdCardCardReviewRoute
  '/$patientId/card/share': typeof AuthenticatedPatientIdCardShareRoute
  '/$patientId/careTeam/alternateAgents': typeof AuthenticatedPatientIdCareTeamAlternateAgentsRoute
  '/$patientId/careTeam/attorneyInfo': typeof AuthenticatedPatientIdCareTeamAttorneyInfoRoute
  '/$patientId/careTeam/doctorInfo': typeof AuthenticatedPatientIdCareTeamDoctorInfoRoute
  '/$patientId/careTeam/hcaInfo': typeof AuthenticatedPatientIdCareTeamHcaInfoRoute
  '/$patientId/careTeam/hospitalInfo': typeof AuthenticatedPatientIdCareTeamHospitalInfoRoute
  '/$patientId/education/patientEducation': typeof AuthenticatedPatientIdEducationPatientEducationRoute
  '/$patientId/education/treatmentOption': typeof AuthenticatedPatientIdEducationTreatmentOptionRoute
  '/$patientId/info/consentForms': typeof AuthenticatedPatientIdInfoConsentFormsRoute
  '/$patientId/info/files': typeof AuthenticatedPatientIdInfoFilesRoute
  '/$patientId/info/govId': typeof AuthenticatedPatientIdInfoGovIdRoute
  '/$patientId/info/patientInfo': typeof AuthenticatedPatientIdInfoPatientInfoRoute
  '/$patientId/info/photoForCard': typeof AuthenticatedPatientIdInfoPhotoForCardRoute
  '/$patientId/onboarding/final': typeof AuthenticatedPatientIdOnboardingFinalRoute
  '/$patientId/onboarding/learn': typeof AuthenticatedPatientIdOnboardingLearnRoute
  '/$patientId/onboarding/onboardingPayment': typeof AuthenticatedPatientIdOnboardingOnboardingPaymentRoute
  '/$patientId/onboarding/questionnaire': typeof AuthenticatedPatientIdOnboardingQuestionnaireRoute
  '/$patientId/onboarding/select': typeof AuthenticatedPatientIdOnboardingSelectRoute
  '/$patientId/payment/aob': typeof AuthenticatedPatientIdPaymentAobRoute
  '/$patientId/payment/confirmPackage': typeof AuthenticatedPatientIdPaymentConfirmPackageRoute
  '/$patientId/payment/insuranceABN': typeof AuthenticatedPatientIdPaymentInsuranceABNRoute
  '/$patientId/payment/insuranceInfo': typeof AuthenticatedPatientIdPaymentInsuranceInfoRoute
  '/$patientId/payment/medicareABN': typeof AuthenticatedPatientIdPaymentMedicareABNRoute
  '/$patientId/payment/medicareInfo': typeof AuthenticatedPatientIdPaymentMedicareInfoRoute
  '/$patientId/payment/selfPay': typeof AuthenticatedPatientIdPaymentSelfPayRoute
  '/$patientId/payment/thanks': typeof AuthenticatedPatientIdPaymentThanksRoute
  '/$patientId/statement/attestation': typeof AuthenticatedPatientIdStatementAttestationRoute
  '/$patientId/statement/finalSignatures': typeof AuthenticatedPatientIdStatementFinalSignaturesRoute
  '/$patientId/statement/instructionalVideos': typeof AuthenticatedPatientIdStatementInstructionalVideosRoute
  '/$patientId/statement/recording': typeof AuthenticatedPatientIdStatementRecordingRoute
  '/$patientId/card/': typeof AuthenticatedPatientIdCardIndexRoute
  '/$patientId/careTeam/': typeof AuthenticatedPatientIdCareTeamIndexRoute
  '/$patientId/education/': typeof AuthenticatedPatientIdEducationIndexRoute
  '/$patientId/info/': typeof AuthenticatedPatientIdInfoIndexRoute
  '/$patientId/onboarding/': typeof AuthenticatedPatientIdOnboardingIndexRoute
  '/$patientId/payment/': typeof AuthenticatedPatientIdPaymentIndexRoute
  '/$patientId/statement/': typeof AuthenticatedPatientIdStatementIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/concierge': typeof ConciergeRoute
  '/enroll': typeof EnrollRoute
  '/login': typeof LoginRoute
  '/passwordless': typeof PasswordlessRoute
  '/privacy': typeof PrivacyRoute
  '/testErrors': typeof TestErrorsRoute
  '/home': typeof AuthenticatedHomeRoute
  '/myMideoFamily': typeof AuthenticatedMyMideoFamilyRoute
  '/sessions': typeof AuthenticatedSessionsRouteWithChildren
  '/welcome': typeof AuthenticatedWelcomeRoute
  '/$patientId/profile': typeof AuthenticatedPatientIdProfileRoute
  '/sessions/$sessionId': typeof AuthenticatedSessionsSessionIdRoute
  '/$patientId': typeof AuthenticatedPatientIdIndexRoute
  '/$patientId/card/addToWallet': typeof AuthenticatedPatientIdCardAddToWalletRoute
  '/$patientId/card/addWidget': typeof AuthenticatedPatientIdCardAddWidgetRoute
  '/$patientId/card/cardReview': typeof AuthenticatedPatientIdCardCardReviewRoute
  '/$patientId/card/share': typeof AuthenticatedPatientIdCardShareRoute
  '/$patientId/careTeam/alternateAgents': typeof AuthenticatedPatientIdCareTeamAlternateAgentsRoute
  '/$patientId/careTeam/attorneyInfo': typeof AuthenticatedPatientIdCareTeamAttorneyInfoRoute
  '/$patientId/careTeam/doctorInfo': typeof AuthenticatedPatientIdCareTeamDoctorInfoRoute
  '/$patientId/careTeam/hcaInfo': typeof AuthenticatedPatientIdCareTeamHcaInfoRoute
  '/$patientId/careTeam/hospitalInfo': typeof AuthenticatedPatientIdCareTeamHospitalInfoRoute
  '/$patientId/education/patientEducation': typeof AuthenticatedPatientIdEducationPatientEducationRoute
  '/$patientId/education/treatmentOption': typeof AuthenticatedPatientIdEducationTreatmentOptionRoute
  '/$patientId/info/consentForms': typeof AuthenticatedPatientIdInfoConsentFormsRoute
  '/$patientId/info/files': typeof AuthenticatedPatientIdInfoFilesRoute
  '/$patientId/info/govId': typeof AuthenticatedPatientIdInfoGovIdRoute
  '/$patientId/info/patientInfo': typeof AuthenticatedPatientIdInfoPatientInfoRoute
  '/$patientId/info/photoForCard': typeof AuthenticatedPatientIdInfoPhotoForCardRoute
  '/$patientId/onboarding/final': typeof AuthenticatedPatientIdOnboardingFinalRoute
  '/$patientId/onboarding/learn': typeof AuthenticatedPatientIdOnboardingLearnRoute
  '/$patientId/onboarding/onboardingPayment': typeof AuthenticatedPatientIdOnboardingOnboardingPaymentRoute
  '/$patientId/onboarding/questionnaire': typeof AuthenticatedPatientIdOnboardingQuestionnaireRoute
  '/$patientId/onboarding/select': typeof AuthenticatedPatientIdOnboardingSelectRoute
  '/$patientId/payment/aob': typeof AuthenticatedPatientIdPaymentAobRoute
  '/$patientId/payment/confirmPackage': typeof AuthenticatedPatientIdPaymentConfirmPackageRoute
  '/$patientId/payment/insuranceABN': typeof AuthenticatedPatientIdPaymentInsuranceABNRoute
  '/$patientId/payment/insuranceInfo': typeof AuthenticatedPatientIdPaymentInsuranceInfoRoute
  '/$patientId/payment/medicareABN': typeof AuthenticatedPatientIdPaymentMedicareABNRoute
  '/$patientId/payment/medicareInfo': typeof AuthenticatedPatientIdPaymentMedicareInfoRoute
  '/$patientId/payment/selfPay': typeof AuthenticatedPatientIdPaymentSelfPayRoute
  '/$patientId/payment/thanks': typeof AuthenticatedPatientIdPaymentThanksRoute
  '/$patientId/statement/attestation': typeof AuthenticatedPatientIdStatementAttestationRoute
  '/$patientId/statement/finalSignatures': typeof AuthenticatedPatientIdStatementFinalSignaturesRoute
  '/$patientId/statement/instructionalVideos': typeof AuthenticatedPatientIdStatementInstructionalVideosRoute
  '/$patientId/statement/recording': typeof AuthenticatedPatientIdStatementRecordingRoute
  '/$patientId/card': typeof AuthenticatedPatientIdCardIndexRoute
  '/$patientId/careTeam': typeof AuthenticatedPatientIdCareTeamIndexRoute
  '/$patientId/education': typeof AuthenticatedPatientIdEducationIndexRoute
  '/$patientId/info': typeof AuthenticatedPatientIdInfoIndexRoute
  '/$patientId/onboarding': typeof AuthenticatedPatientIdOnboardingIndexRoute
  '/$patientId/payment': typeof AuthenticatedPatientIdPaymentIndexRoute
  '/$patientId/statement': typeof AuthenticatedPatientIdStatementIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/concierge': typeof ConciergeRoute
  '/enroll': typeof EnrollRoute
  '/login': typeof LoginRoute
  '/passwordless': typeof PasswordlessRoute
  '/privacy': typeof PrivacyRoute
  '/testErrors': typeof TestErrorsRoute
  '/_authenticated/$patientId': typeof AuthenticatedPatientIdRouteWithChildren
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/myMideoFamily': typeof AuthenticatedMyMideoFamilyRoute
  '/_authenticated/sessions': typeof AuthenticatedSessionsRouteWithChildren
  '/_authenticated/welcome': typeof AuthenticatedWelcomeRoute
  '/_authenticated/$patientId/profile': typeof AuthenticatedPatientIdProfileRoute
  '/_authenticated/sessions/$sessionId': typeof AuthenticatedSessionsSessionIdRoute
  '/_authenticated/$patientId/': typeof AuthenticatedPatientIdIndexRoute
  '/_authenticated/$patientId/card/addToWallet': typeof AuthenticatedPatientIdCardAddToWalletRoute
  '/_authenticated/$patientId/card/addWidget': typeof AuthenticatedPatientIdCardAddWidgetRoute
  '/_authenticated/$patientId/card/cardReview': typeof AuthenticatedPatientIdCardCardReviewRoute
  '/_authenticated/$patientId/card/share': typeof AuthenticatedPatientIdCardShareRoute
  '/_authenticated/$patientId/careTeam/alternateAgents': typeof AuthenticatedPatientIdCareTeamAlternateAgentsRoute
  '/_authenticated/$patientId/careTeam/attorneyInfo': typeof AuthenticatedPatientIdCareTeamAttorneyInfoRoute
  '/_authenticated/$patientId/careTeam/doctorInfo': typeof AuthenticatedPatientIdCareTeamDoctorInfoRoute
  '/_authenticated/$patientId/careTeam/hcaInfo': typeof AuthenticatedPatientIdCareTeamHcaInfoRoute
  '/_authenticated/$patientId/careTeam/hospitalInfo': typeof AuthenticatedPatientIdCareTeamHospitalInfoRoute
  '/_authenticated/$patientId/education/patientEducation': typeof AuthenticatedPatientIdEducationPatientEducationRoute
  '/_authenticated/$patientId/education/treatmentOption': typeof AuthenticatedPatientIdEducationTreatmentOptionRoute
  '/_authenticated/$patientId/info/consentForms': typeof AuthenticatedPatientIdInfoConsentFormsRoute
  '/_authenticated/$patientId/info/files': typeof AuthenticatedPatientIdInfoFilesRoute
  '/_authenticated/$patientId/info/govId': typeof AuthenticatedPatientIdInfoGovIdRoute
  '/_authenticated/$patientId/info/patientInfo': typeof AuthenticatedPatientIdInfoPatientInfoRoute
  '/_authenticated/$patientId/info/photoForCard': typeof AuthenticatedPatientIdInfoPhotoForCardRoute
  '/_authenticated/$patientId/onboarding/final': typeof AuthenticatedPatientIdOnboardingFinalRoute
  '/_authenticated/$patientId/onboarding/learn': typeof AuthenticatedPatientIdOnboardingLearnRoute
  '/_authenticated/$patientId/onboarding/onboardingPayment': typeof AuthenticatedPatientIdOnboardingOnboardingPaymentRoute
  '/_authenticated/$patientId/onboarding/questionnaire': typeof AuthenticatedPatientIdOnboardingQuestionnaireRoute
  '/_authenticated/$patientId/onboarding/select': typeof AuthenticatedPatientIdOnboardingSelectRoute
  '/_authenticated/$patientId/payment/aob': typeof AuthenticatedPatientIdPaymentAobRoute
  '/_authenticated/$patientId/payment/confirmPackage': typeof AuthenticatedPatientIdPaymentConfirmPackageRoute
  '/_authenticated/$patientId/payment/insuranceABN': typeof AuthenticatedPatientIdPaymentInsuranceABNRoute
  '/_authenticated/$patientId/payment/insuranceInfo': typeof AuthenticatedPatientIdPaymentInsuranceInfoRoute
  '/_authenticated/$patientId/payment/medicareABN': typeof AuthenticatedPatientIdPaymentMedicareABNRoute
  '/_authenticated/$patientId/payment/medicareInfo': typeof AuthenticatedPatientIdPaymentMedicareInfoRoute
  '/_authenticated/$patientId/payment/selfPay': typeof AuthenticatedPatientIdPaymentSelfPayRoute
  '/_authenticated/$patientId/payment/thanks': typeof AuthenticatedPatientIdPaymentThanksRoute
  '/_authenticated/$patientId/statement/attestation': typeof AuthenticatedPatientIdStatementAttestationRoute
  '/_authenticated/$patientId/statement/finalSignatures': typeof AuthenticatedPatientIdStatementFinalSignaturesRoute
  '/_authenticated/$patientId/statement/instructionalVideos': typeof AuthenticatedPatientIdStatementInstructionalVideosRoute
  '/_authenticated/$patientId/statement/recording': typeof AuthenticatedPatientIdStatementRecordingRoute
  '/_authenticated/$patientId/card/': typeof AuthenticatedPatientIdCardIndexRoute
  '/_authenticated/$patientId/careTeam/': typeof AuthenticatedPatientIdCareTeamIndexRoute
  '/_authenticated/$patientId/education/': typeof AuthenticatedPatientIdEducationIndexRoute
  '/_authenticated/$patientId/info/': typeof AuthenticatedPatientIdInfoIndexRoute
  '/_authenticated/$patientId/onboarding/': typeof AuthenticatedPatientIdOnboardingIndexRoute
  '/_authenticated/$patientId/payment/': typeof AuthenticatedPatientIdPaymentIndexRoute
  '/_authenticated/$patientId/statement/': typeof AuthenticatedPatientIdStatementIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/concierge'
    | '/enroll'
    | '/login'
    | '/passwordless'
    | '/privacy'
    | '/testErrors'
    | '/$patientId'
    | '/home'
    | '/myMideoFamily'
    | '/sessions'
    | '/welcome'
    | '/$patientId/profile'
    | '/sessions/$sessionId'
    | '/$patientId/'
    | '/$patientId/card/addToWallet'
    | '/$patientId/card/addWidget'
    | '/$patientId/card/cardReview'
    | '/$patientId/card/share'
    | '/$patientId/careTeam/alternateAgents'
    | '/$patientId/careTeam/attorneyInfo'
    | '/$patientId/careTeam/doctorInfo'
    | '/$patientId/careTeam/hcaInfo'
    | '/$patientId/careTeam/hospitalInfo'
    | '/$patientId/education/patientEducation'
    | '/$patientId/education/treatmentOption'
    | '/$patientId/info/consentForms'
    | '/$patientId/info/files'
    | '/$patientId/info/govId'
    | '/$patientId/info/patientInfo'
    | '/$patientId/info/photoForCard'
    | '/$patientId/onboarding/final'
    | '/$patientId/onboarding/learn'
    | '/$patientId/onboarding/onboardingPayment'
    | '/$patientId/onboarding/questionnaire'
    | '/$patientId/onboarding/select'
    | '/$patientId/payment/aob'
    | '/$patientId/payment/confirmPackage'
    | '/$patientId/payment/insuranceABN'
    | '/$patientId/payment/insuranceInfo'
    | '/$patientId/payment/medicareABN'
    | '/$patientId/payment/medicareInfo'
    | '/$patientId/payment/selfPay'
    | '/$patientId/payment/thanks'
    | '/$patientId/statement/attestation'
    | '/$patientId/statement/finalSignatures'
    | '/$patientId/statement/instructionalVideos'
    | '/$patientId/statement/recording'
    | '/$patientId/card/'
    | '/$patientId/careTeam/'
    | '/$patientId/education/'
    | '/$patientId/info/'
    | '/$patientId/onboarding/'
    | '/$patientId/payment/'
    | '/$patientId/statement/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/concierge'
    | '/enroll'
    | '/login'
    | '/passwordless'
    | '/privacy'
    | '/testErrors'
    | '/home'
    | '/myMideoFamily'
    | '/sessions'
    | '/welcome'
    | '/$patientId/profile'
    | '/sessions/$sessionId'
    | '/$patientId'
    | '/$patientId/card/addToWallet'
    | '/$patientId/card/addWidget'
    | '/$patientId/card/cardReview'
    | '/$patientId/card/share'
    | '/$patientId/careTeam/alternateAgents'
    | '/$patientId/careTeam/attorneyInfo'
    | '/$patientId/careTeam/doctorInfo'
    | '/$patientId/careTeam/hcaInfo'
    | '/$patientId/careTeam/hospitalInfo'
    | '/$patientId/education/patientEducation'
    | '/$patientId/education/treatmentOption'
    | '/$patientId/info/consentForms'
    | '/$patientId/info/files'
    | '/$patientId/info/govId'
    | '/$patientId/info/patientInfo'
    | '/$patientId/info/photoForCard'
    | '/$patientId/onboarding/final'
    | '/$patientId/onboarding/learn'
    | '/$patientId/onboarding/onboardingPayment'
    | '/$patientId/onboarding/questionnaire'
    | '/$patientId/onboarding/select'
    | '/$patientId/payment/aob'
    | '/$patientId/payment/confirmPackage'
    | '/$patientId/payment/insuranceABN'
    | '/$patientId/payment/insuranceInfo'
    | '/$patientId/payment/medicareABN'
    | '/$patientId/payment/medicareInfo'
    | '/$patientId/payment/selfPay'
    | '/$patientId/payment/thanks'
    | '/$patientId/statement/attestation'
    | '/$patientId/statement/finalSignatures'
    | '/$patientId/statement/instructionalVideos'
    | '/$patientId/statement/recording'
    | '/$patientId/card'
    | '/$patientId/careTeam'
    | '/$patientId/education'
    | '/$patientId/info'
    | '/$patientId/onboarding'
    | '/$patientId/payment'
    | '/$patientId/statement'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/concierge'
    | '/enroll'
    | '/login'
    | '/passwordless'
    | '/privacy'
    | '/testErrors'
    | '/_authenticated/$patientId'
    | '/_authenticated/home'
    | '/_authenticated/myMideoFamily'
    | '/_authenticated/sessions'
    | '/_authenticated/welcome'
    | '/_authenticated/$patientId/profile'
    | '/_authenticated/sessions/$sessionId'
    | '/_authenticated/$patientId/'
    | '/_authenticated/$patientId/card/addToWallet'
    | '/_authenticated/$patientId/card/addWidget'
    | '/_authenticated/$patientId/card/cardReview'
    | '/_authenticated/$patientId/card/share'
    | '/_authenticated/$patientId/careTeam/alternateAgents'
    | '/_authenticated/$patientId/careTeam/attorneyInfo'
    | '/_authenticated/$patientId/careTeam/doctorInfo'
    | '/_authenticated/$patientId/careTeam/hcaInfo'
    | '/_authenticated/$patientId/careTeam/hospitalInfo'
    | '/_authenticated/$patientId/education/patientEducation'
    | '/_authenticated/$patientId/education/treatmentOption'
    | '/_authenticated/$patientId/info/consentForms'
    | '/_authenticated/$patientId/info/files'
    | '/_authenticated/$patientId/info/govId'
    | '/_authenticated/$patientId/info/patientInfo'
    | '/_authenticated/$patientId/info/photoForCard'
    | '/_authenticated/$patientId/onboarding/final'
    | '/_authenticated/$patientId/onboarding/learn'
    | '/_authenticated/$patientId/onboarding/onboardingPayment'
    | '/_authenticated/$patientId/onboarding/questionnaire'
    | '/_authenticated/$patientId/onboarding/select'
    | '/_authenticated/$patientId/payment/aob'
    | '/_authenticated/$patientId/payment/confirmPackage'
    | '/_authenticated/$patientId/payment/insuranceABN'
    | '/_authenticated/$patientId/payment/insuranceInfo'
    | '/_authenticated/$patientId/payment/medicareABN'
    | '/_authenticated/$patientId/payment/medicareInfo'
    | '/_authenticated/$patientId/payment/selfPay'
    | '/_authenticated/$patientId/payment/thanks'
    | '/_authenticated/$patientId/statement/attestation'
    | '/_authenticated/$patientId/statement/finalSignatures'
    | '/_authenticated/$patientId/statement/instructionalVideos'
    | '/_authenticated/$patientId/statement/recording'
    | '/_authenticated/$patientId/card/'
    | '/_authenticated/$patientId/careTeam/'
    | '/_authenticated/$patientId/education/'
    | '/_authenticated/$patientId/info/'
    | '/_authenticated/$patientId/onboarding/'
    | '/_authenticated/$patientId/payment/'
    | '/_authenticated/$patientId/statement/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ConciergeRoute: typeof ConciergeRoute
  EnrollRoute: typeof EnrollRoute
  LoginRoute: typeof LoginRoute
  PasswordlessRoute: typeof PasswordlessRoute
  PrivacyRoute: typeof PrivacyRoute
  TestErrorsRoute: typeof TestErrorsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/testErrors': {
      id: '/testErrors'
      path: '/testErrors'
      fullPath: '/testErrors'
      preLoaderRoute: typeof TestErrorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/passwordless': {
      id: '/passwordless'
      path: '/passwordless'
      fullPath: '/passwordless'
      preLoaderRoute: typeof PasswordlessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enroll': {
      id: '/enroll'
      path: '/enroll'
      fullPath: '/enroll'
      preLoaderRoute: typeof EnrollRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/concierge': {
      id: '/concierge'
      path: '/concierge'
      fullPath: '/concierge'
      preLoaderRoute: typeof ConciergeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/welcome': {
      id: '/_authenticated/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AuthenticatedWelcomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sessions': {
      id: '/_authenticated/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof AuthenticatedSessionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/myMideoFamily': {
      id: '/_authenticated/myMideoFamily'
      path: '/myMideoFamily'
      fullPath: '/myMideoFamily'
      preLoaderRoute: typeof AuthenticatedMyMideoFamilyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$patientId': {
      id: '/_authenticated/$patientId'
      path: '/$patientId'
      fullPath: '/$patientId'
      preLoaderRoute: typeof AuthenticatedPatientIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$patientId/': {
      id: '/_authenticated/$patientId/'
      path: '/'
      fullPath: '/$patientId/'
      preLoaderRoute: typeof AuthenticatedPatientIdIndexRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/sessions/$sessionId': {
      id: '/_authenticated/sessions/$sessionId'
      path: '/$sessionId'
      fullPath: '/sessions/$sessionId'
      preLoaderRoute: typeof AuthenticatedSessionsSessionIdRouteImport
      parentRoute: typeof AuthenticatedSessionsRoute
    }
    '/_authenticated/$patientId/profile': {
      id: '/_authenticated/$patientId/profile'
      path: '/profile'
      fullPath: '/$patientId/profile'
      preLoaderRoute: typeof AuthenticatedPatientIdProfileRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/statement/': {
      id: '/_authenticated/$patientId/statement/'
      path: '/statement'
      fullPath: '/$patientId/statement/'
      preLoaderRoute: typeof AuthenticatedPatientIdStatementIndexRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/payment/': {
      id: '/_authenticated/$patientId/payment/'
      path: '/payment'
      fullPath: '/$patientId/payment/'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentIndexRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/onboarding/': {
      id: '/_authenticated/$patientId/onboarding/'
      path: '/onboarding'
      fullPath: '/$patientId/onboarding/'
      preLoaderRoute: typeof AuthenticatedPatientIdOnboardingIndexRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/info/': {
      id: '/_authenticated/$patientId/info/'
      path: '/info'
      fullPath: '/$patientId/info/'
      preLoaderRoute: typeof AuthenticatedPatientIdInfoIndexRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/education/': {
      id: '/_authenticated/$patientId/education/'
      path: '/education'
      fullPath: '/$patientId/education/'
      preLoaderRoute: typeof AuthenticatedPatientIdEducationIndexRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/careTeam/': {
      id: '/_authenticated/$patientId/careTeam/'
      path: '/careTeam'
      fullPath: '/$patientId/careTeam/'
      preLoaderRoute: typeof AuthenticatedPatientIdCareTeamIndexRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/card/': {
      id: '/_authenticated/$patientId/card/'
      path: '/card'
      fullPath: '/$patientId/card/'
      preLoaderRoute: typeof AuthenticatedPatientIdCardIndexRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/statement/recording': {
      id: '/_authenticated/$patientId/statement/recording'
      path: '/statement/recording'
      fullPath: '/$patientId/statement/recording'
      preLoaderRoute: typeof AuthenticatedPatientIdStatementRecordingRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/statement/instructionalVideos': {
      id: '/_authenticated/$patientId/statement/instructionalVideos'
      path: '/statement/instructionalVideos'
      fullPath: '/$patientId/statement/instructionalVideos'
      preLoaderRoute: typeof AuthenticatedPatientIdStatementInstructionalVideosRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/statement/finalSignatures': {
      id: '/_authenticated/$patientId/statement/finalSignatures'
      path: '/statement/finalSignatures'
      fullPath: '/$patientId/statement/finalSignatures'
      preLoaderRoute: typeof AuthenticatedPatientIdStatementFinalSignaturesRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/statement/attestation': {
      id: '/_authenticated/$patientId/statement/attestation'
      path: '/statement/attestation'
      fullPath: '/$patientId/statement/attestation'
      preLoaderRoute: typeof AuthenticatedPatientIdStatementAttestationRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/payment/thanks': {
      id: '/_authenticated/$patientId/payment/thanks'
      path: '/payment/thanks'
      fullPath: '/$patientId/payment/thanks'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentThanksRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/payment/selfPay': {
      id: '/_authenticated/$patientId/payment/selfPay'
      path: '/payment/selfPay'
      fullPath: '/$patientId/payment/selfPay'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentSelfPayRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/payment/medicareInfo': {
      id: '/_authenticated/$patientId/payment/medicareInfo'
      path: '/payment/medicareInfo'
      fullPath: '/$patientId/payment/medicareInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentMedicareInfoRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/payment/medicareABN': {
      id: '/_authenticated/$patientId/payment/medicareABN'
      path: '/payment/medicareABN'
      fullPath: '/$patientId/payment/medicareABN'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentMedicareABNRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/payment/insuranceInfo': {
      id: '/_authenticated/$patientId/payment/insuranceInfo'
      path: '/payment/insuranceInfo'
      fullPath: '/$patientId/payment/insuranceInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentInsuranceInfoRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/payment/insuranceABN': {
      id: '/_authenticated/$patientId/payment/insuranceABN'
      path: '/payment/insuranceABN'
      fullPath: '/$patientId/payment/insuranceABN'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentInsuranceABNRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/payment/confirmPackage': {
      id: '/_authenticated/$patientId/payment/confirmPackage'
      path: '/payment/confirmPackage'
      fullPath: '/$patientId/payment/confirmPackage'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentConfirmPackageRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/payment/aob': {
      id: '/_authenticated/$patientId/payment/aob'
      path: '/payment/aob'
      fullPath: '/$patientId/payment/aob'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentAobRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/onboarding/select': {
      id: '/_authenticated/$patientId/onboarding/select'
      path: '/onboarding/select'
      fullPath: '/$patientId/onboarding/select'
      preLoaderRoute: typeof AuthenticatedPatientIdOnboardingSelectRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/onboarding/questionnaire': {
      id: '/_authenticated/$patientId/onboarding/questionnaire'
      path: '/onboarding/questionnaire'
      fullPath: '/$patientId/onboarding/questionnaire'
      preLoaderRoute: typeof AuthenticatedPatientIdOnboardingQuestionnaireRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/onboarding/onboardingPayment': {
      id: '/_authenticated/$patientId/onboarding/onboardingPayment'
      path: '/onboarding/onboardingPayment'
      fullPath: '/$patientId/onboarding/onboardingPayment'
      preLoaderRoute: typeof AuthenticatedPatientIdOnboardingOnboardingPaymentRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/onboarding/learn': {
      id: '/_authenticated/$patientId/onboarding/learn'
      path: '/onboarding/learn'
      fullPath: '/$patientId/onboarding/learn'
      preLoaderRoute: typeof AuthenticatedPatientIdOnboardingLearnRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/onboarding/final': {
      id: '/_authenticated/$patientId/onboarding/final'
      path: '/onboarding/final'
      fullPath: '/$patientId/onboarding/final'
      preLoaderRoute: typeof AuthenticatedPatientIdOnboardingFinalRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/info/photoForCard': {
      id: '/_authenticated/$patientId/info/photoForCard'
      path: '/info/photoForCard'
      fullPath: '/$patientId/info/photoForCard'
      preLoaderRoute: typeof AuthenticatedPatientIdInfoPhotoForCardRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/info/patientInfo': {
      id: '/_authenticated/$patientId/info/patientInfo'
      path: '/info/patientInfo'
      fullPath: '/$patientId/info/patientInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdInfoPatientInfoRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/info/govId': {
      id: '/_authenticated/$patientId/info/govId'
      path: '/info/govId'
      fullPath: '/$patientId/info/govId'
      preLoaderRoute: typeof AuthenticatedPatientIdInfoGovIdRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/info/files': {
      id: '/_authenticated/$patientId/info/files'
      path: '/info/files'
      fullPath: '/$patientId/info/files'
      preLoaderRoute: typeof AuthenticatedPatientIdInfoFilesRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/info/consentForms': {
      id: '/_authenticated/$patientId/info/consentForms'
      path: '/info/consentForms'
      fullPath: '/$patientId/info/consentForms'
      preLoaderRoute: typeof AuthenticatedPatientIdInfoConsentFormsRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/education/treatmentOption': {
      id: '/_authenticated/$patientId/education/treatmentOption'
      path: '/education/treatmentOption'
      fullPath: '/$patientId/education/treatmentOption'
      preLoaderRoute: typeof AuthenticatedPatientIdEducationTreatmentOptionRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/education/patientEducation': {
      id: '/_authenticated/$patientId/education/patientEducation'
      path: '/education/patientEducation'
      fullPath: '/$patientId/education/patientEducation'
      preLoaderRoute: typeof AuthenticatedPatientIdEducationPatientEducationRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/careTeam/hospitalInfo': {
      id: '/_authenticated/$patientId/careTeam/hospitalInfo'
      path: '/careTeam/hospitalInfo'
      fullPath: '/$patientId/careTeam/hospitalInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdCareTeamHospitalInfoRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/careTeam/hcaInfo': {
      id: '/_authenticated/$patientId/careTeam/hcaInfo'
      path: '/careTeam/hcaInfo'
      fullPath: '/$patientId/careTeam/hcaInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdCareTeamHcaInfoRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/careTeam/doctorInfo': {
      id: '/_authenticated/$patientId/careTeam/doctorInfo'
      path: '/careTeam/doctorInfo'
      fullPath: '/$patientId/careTeam/doctorInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdCareTeamDoctorInfoRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/careTeam/attorneyInfo': {
      id: '/_authenticated/$patientId/careTeam/attorneyInfo'
      path: '/careTeam/attorneyInfo'
      fullPath: '/$patientId/careTeam/attorneyInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdCareTeamAttorneyInfoRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/careTeam/alternateAgents': {
      id: '/_authenticated/$patientId/careTeam/alternateAgents'
      path: '/careTeam/alternateAgents'
      fullPath: '/$patientId/careTeam/alternateAgents'
      preLoaderRoute: typeof AuthenticatedPatientIdCareTeamAlternateAgentsRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/card/share': {
      id: '/_authenticated/$patientId/card/share'
      path: '/card/share'
      fullPath: '/$patientId/card/share'
      preLoaderRoute: typeof AuthenticatedPatientIdCardShareRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/card/cardReview': {
      id: '/_authenticated/$patientId/card/cardReview'
      path: '/card/cardReview'
      fullPath: '/$patientId/card/cardReview'
      preLoaderRoute: typeof AuthenticatedPatientIdCardCardReviewRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/card/addWidget': {
      id: '/_authenticated/$patientId/card/addWidget'
      path: '/card/addWidget'
      fullPath: '/$patientId/card/addWidget'
      preLoaderRoute: typeof AuthenticatedPatientIdCardAddWidgetRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
    '/_authenticated/$patientId/card/addToWallet': {
      id: '/_authenticated/$patientId/card/addToWallet'
      path: '/card/addToWallet'
      fullPath: '/$patientId/card/addToWallet'
      preLoaderRoute: typeof AuthenticatedPatientIdCardAddToWalletRouteImport
      parentRoute: typeof AuthenticatedPatientIdRoute
    }
  }
}

interface AuthenticatedPatientIdRouteChildren {
  AuthenticatedPatientIdProfileRoute: typeof AuthenticatedPatientIdProfileRoute
  AuthenticatedPatientIdIndexRoute: typeof AuthenticatedPatientIdIndexRoute
  AuthenticatedPatientIdCardAddToWalletRoute: typeof AuthenticatedPatientIdCardAddToWalletRoute
  AuthenticatedPatientIdCardAddWidgetRoute: typeof AuthenticatedPatientIdCardAddWidgetRoute
  AuthenticatedPatientIdCardCardReviewRoute: typeof AuthenticatedPatientIdCardCardReviewRoute
  AuthenticatedPatientIdCardShareRoute: typeof AuthenticatedPatientIdCardShareRoute
  AuthenticatedPatientIdCareTeamAlternateAgentsRoute: typeof AuthenticatedPatientIdCareTeamAlternateAgentsRoute
  AuthenticatedPatientIdCareTeamAttorneyInfoRoute: typeof AuthenticatedPatientIdCareTeamAttorneyInfoRoute
  AuthenticatedPatientIdCareTeamDoctorInfoRoute: typeof AuthenticatedPatientIdCareTeamDoctorInfoRoute
  AuthenticatedPatientIdCareTeamHcaInfoRoute: typeof AuthenticatedPatientIdCareTeamHcaInfoRoute
  AuthenticatedPatientIdCareTeamHospitalInfoRoute: typeof AuthenticatedPatientIdCareTeamHospitalInfoRoute
  AuthenticatedPatientIdEducationPatientEducationRoute: typeof AuthenticatedPatientIdEducationPatientEducationRoute
  AuthenticatedPatientIdEducationTreatmentOptionRoute: typeof AuthenticatedPatientIdEducationTreatmentOptionRoute
  AuthenticatedPatientIdInfoConsentFormsRoute: typeof AuthenticatedPatientIdInfoConsentFormsRoute
  AuthenticatedPatientIdInfoFilesRoute: typeof AuthenticatedPatientIdInfoFilesRoute
  AuthenticatedPatientIdInfoGovIdRoute: typeof AuthenticatedPatientIdInfoGovIdRoute
  AuthenticatedPatientIdInfoPatientInfoRoute: typeof AuthenticatedPatientIdInfoPatientInfoRoute
  AuthenticatedPatientIdInfoPhotoForCardRoute: typeof AuthenticatedPatientIdInfoPhotoForCardRoute
  AuthenticatedPatientIdOnboardingFinalRoute: typeof AuthenticatedPatientIdOnboardingFinalRoute
  AuthenticatedPatientIdOnboardingLearnRoute: typeof AuthenticatedPatientIdOnboardingLearnRoute
  AuthenticatedPatientIdOnboardingOnboardingPaymentRoute: typeof AuthenticatedPatientIdOnboardingOnboardingPaymentRoute
  AuthenticatedPatientIdOnboardingQuestionnaireRoute: typeof AuthenticatedPatientIdOnboardingQuestionnaireRoute
  AuthenticatedPatientIdOnboardingSelectRoute: typeof AuthenticatedPatientIdOnboardingSelectRoute
  AuthenticatedPatientIdPaymentAobRoute: typeof AuthenticatedPatientIdPaymentAobRoute
  AuthenticatedPatientIdPaymentConfirmPackageRoute: typeof AuthenticatedPatientIdPaymentConfirmPackageRoute
  AuthenticatedPatientIdPaymentInsuranceABNRoute: typeof AuthenticatedPatientIdPaymentInsuranceABNRoute
  AuthenticatedPatientIdPaymentInsuranceInfoRoute: typeof AuthenticatedPatientIdPaymentInsuranceInfoRoute
  AuthenticatedPatientIdPaymentMedicareABNRoute: typeof AuthenticatedPatientIdPaymentMedicareABNRoute
  AuthenticatedPatientIdPaymentMedicareInfoRoute: typeof AuthenticatedPatientIdPaymentMedicareInfoRoute
  AuthenticatedPatientIdPaymentSelfPayRoute: typeof AuthenticatedPatientIdPaymentSelfPayRoute
  AuthenticatedPatientIdPaymentThanksRoute: typeof AuthenticatedPatientIdPaymentThanksRoute
  AuthenticatedPatientIdStatementAttestationRoute: typeof AuthenticatedPatientIdStatementAttestationRoute
  AuthenticatedPatientIdStatementFinalSignaturesRoute: typeof AuthenticatedPatientIdStatementFinalSignaturesRoute
  AuthenticatedPatientIdStatementInstructionalVideosRoute: typeof AuthenticatedPatientIdStatementInstructionalVideosRoute
  AuthenticatedPatientIdStatementRecordingRoute: typeof AuthenticatedPatientIdStatementRecordingRoute
  AuthenticatedPatientIdCardIndexRoute: typeof AuthenticatedPatientIdCardIndexRoute
  AuthenticatedPatientIdCareTeamIndexRoute: typeof AuthenticatedPatientIdCareTeamIndexRoute
  AuthenticatedPatientIdEducationIndexRoute: typeof AuthenticatedPatientIdEducationIndexRoute
  AuthenticatedPatientIdInfoIndexRoute: typeof AuthenticatedPatientIdInfoIndexRoute
  AuthenticatedPatientIdOnboardingIndexRoute: typeof AuthenticatedPatientIdOnboardingIndexRoute
  AuthenticatedPatientIdPaymentIndexRoute: typeof AuthenticatedPatientIdPaymentIndexRoute
  AuthenticatedPatientIdStatementIndexRoute: typeof AuthenticatedPatientIdStatementIndexRoute
}

const AuthenticatedPatientIdRouteChildren: AuthenticatedPatientIdRouteChildren =
  {
    AuthenticatedPatientIdProfileRoute: AuthenticatedPatientIdProfileRoute,
    AuthenticatedPatientIdIndexRoute: AuthenticatedPatientIdIndexRoute,
    AuthenticatedPatientIdCardAddToWalletRoute:
      AuthenticatedPatientIdCardAddToWalletRoute,
    AuthenticatedPatientIdCardAddWidgetRoute:
      AuthenticatedPatientIdCardAddWidgetRoute,
    AuthenticatedPatientIdCardCardReviewRoute:
      AuthenticatedPatientIdCardCardReviewRoute,
    AuthenticatedPatientIdCardShareRoute: AuthenticatedPatientIdCardShareRoute,
    AuthenticatedPatientIdCareTeamAlternateAgentsRoute:
      AuthenticatedPatientIdCareTeamAlternateAgentsRoute,
    AuthenticatedPatientIdCareTeamAttorneyInfoRoute:
      AuthenticatedPatientIdCareTeamAttorneyInfoRoute,
    AuthenticatedPatientIdCareTeamDoctorInfoRoute:
      AuthenticatedPatientIdCareTeamDoctorInfoRoute,
    AuthenticatedPatientIdCareTeamHcaInfoRoute:
      AuthenticatedPatientIdCareTeamHcaInfoRoute,
    AuthenticatedPatientIdCareTeamHospitalInfoRoute:
      AuthenticatedPatientIdCareTeamHospitalInfoRoute,
    AuthenticatedPatientIdEducationPatientEducationRoute:
      AuthenticatedPatientIdEducationPatientEducationRoute,
    AuthenticatedPatientIdEducationTreatmentOptionRoute:
      AuthenticatedPatientIdEducationTreatmentOptionRoute,
    AuthenticatedPatientIdInfoConsentFormsRoute:
      AuthenticatedPatientIdInfoConsentFormsRoute,
    AuthenticatedPatientIdInfoFilesRoute: AuthenticatedPatientIdInfoFilesRoute,
    AuthenticatedPatientIdInfoGovIdRoute: AuthenticatedPatientIdInfoGovIdRoute,
    AuthenticatedPatientIdInfoPatientInfoRoute:
      AuthenticatedPatientIdInfoPatientInfoRoute,
    AuthenticatedPatientIdInfoPhotoForCardRoute:
      AuthenticatedPatientIdInfoPhotoForCardRoute,
    AuthenticatedPatientIdOnboardingFinalRoute:
      AuthenticatedPatientIdOnboardingFinalRoute,
    AuthenticatedPatientIdOnboardingLearnRoute:
      AuthenticatedPatientIdOnboardingLearnRoute,
    AuthenticatedPatientIdOnboardingOnboardingPaymentRoute:
      AuthenticatedPatientIdOnboardingOnboardingPaymentRoute,
    AuthenticatedPatientIdOnboardingQuestionnaireRoute:
      AuthenticatedPatientIdOnboardingQuestionnaireRoute,
    AuthenticatedPatientIdOnboardingSelectRoute:
      AuthenticatedPatientIdOnboardingSelectRoute,
    AuthenticatedPatientIdPaymentAobRoute:
      AuthenticatedPatientIdPaymentAobRoute,
    AuthenticatedPatientIdPaymentConfirmPackageRoute:
      AuthenticatedPatientIdPaymentConfirmPackageRoute,
    AuthenticatedPatientIdPaymentInsuranceABNRoute:
      AuthenticatedPatientIdPaymentInsuranceABNRoute,
    AuthenticatedPatientIdPaymentInsuranceInfoRoute:
      AuthenticatedPatientIdPaymentInsuranceInfoRoute,
    AuthenticatedPatientIdPaymentMedicareABNRoute:
      AuthenticatedPatientIdPaymentMedicareABNRoute,
    AuthenticatedPatientIdPaymentMedicareInfoRoute:
      AuthenticatedPatientIdPaymentMedicareInfoRoute,
    AuthenticatedPatientIdPaymentSelfPayRoute:
      AuthenticatedPatientIdPaymentSelfPayRoute,
    AuthenticatedPatientIdPaymentThanksRoute:
      AuthenticatedPatientIdPaymentThanksRoute,
    AuthenticatedPatientIdStatementAttestationRoute:
      AuthenticatedPatientIdStatementAttestationRoute,
    AuthenticatedPatientIdStatementFinalSignaturesRoute:
      AuthenticatedPatientIdStatementFinalSignaturesRoute,
    AuthenticatedPatientIdStatementInstructionalVideosRoute:
      AuthenticatedPatientIdStatementInstructionalVideosRoute,
    AuthenticatedPatientIdStatementRecordingRoute:
      AuthenticatedPatientIdStatementRecordingRoute,
    AuthenticatedPatientIdCardIndexRoute: AuthenticatedPatientIdCardIndexRoute,
    AuthenticatedPatientIdCareTeamIndexRoute:
      AuthenticatedPatientIdCareTeamIndexRoute,
    AuthenticatedPatientIdEducationIndexRoute:
      AuthenticatedPatientIdEducationIndexRoute,
    AuthenticatedPatientIdInfoIndexRoute: AuthenticatedPatientIdInfoIndexRoute,
    AuthenticatedPatientIdOnboardingIndexRoute:
      AuthenticatedPatientIdOnboardingIndexRoute,
    AuthenticatedPatientIdPaymentIndexRoute:
      AuthenticatedPatientIdPaymentIndexRoute,
    AuthenticatedPatientIdStatementIndexRoute:
      AuthenticatedPatientIdStatementIndexRoute,
  }

const AuthenticatedPatientIdRouteWithChildren =
  AuthenticatedPatientIdRoute._addFileChildren(
    AuthenticatedPatientIdRouteChildren,
  )

interface AuthenticatedSessionsRouteChildren {
  AuthenticatedSessionsSessionIdRoute: typeof AuthenticatedSessionsSessionIdRoute
}

const AuthenticatedSessionsRouteChildren: AuthenticatedSessionsRouteChildren = {
  AuthenticatedSessionsSessionIdRoute: AuthenticatedSessionsSessionIdRoute,
}

const AuthenticatedSessionsRouteWithChildren =
  AuthenticatedSessionsRoute._addFileChildren(
    AuthenticatedSessionsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedPatientIdRoute: typeof AuthenticatedPatientIdRouteWithChildren
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedMyMideoFamilyRoute: typeof AuthenticatedMyMideoFamilyRoute
  AuthenticatedSessionsRoute: typeof AuthenticatedSessionsRouteWithChildren
  AuthenticatedWelcomeRoute: typeof AuthenticatedWelcomeRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedPatientIdRoute: AuthenticatedPatientIdRouteWithChildren,
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedMyMideoFamilyRoute: AuthenticatedMyMideoFamilyRoute,
  AuthenticatedSessionsRoute: AuthenticatedSessionsRouteWithChildren,
  AuthenticatedWelcomeRoute: AuthenticatedWelcomeRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ConciergeRoute: ConciergeRoute,
  EnrollRoute: EnrollRoute,
  LoginRoute: LoginRoute,
  PasswordlessRoute: PasswordlessRoute,
  PrivacyRoute: PrivacyRoute,
  TestErrorsRoute: TestErrorsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
